import axios from "axios";

// The Analytics branch preview is intentionally isolated from production.
// These values are scoped to the stable Pages branch hostname and must be removed before merging.
const BRANCH_PREVIEW_HOST = "feature-analytics-interactio.ananawi-site.pages.dev";
const BRANCH_PREVIEW_API = "https://feature-analytics-interaction-filters-2026-10-16-ananawi-api.it-ananawi.workers.dev";
const isBranchPreview = typeof window !== "undefined" && window.location.hostname === BRANCH_PREVIEW_HOST;
const BASE = isBranchPreview
  ? BRANCH_PREVIEW_API
  : process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

// The branch preview always uses the Cloudflare Worker OAuth route.
// Production behavior remains controlled by its existing build variable.
export const IS_CF = isBranchPreview || process.env.REACT_APP_PLATFORM === "cloudflare";

export const http = axios.create({ baseURL: API || undefined, withCredentials: true, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN" });

export const safeGet = async (path, fallback) => {
  if (!API) return fallback;
  try {
    const { data } = await http.get(path);
    return data ?? fallback;
  } catch {
    return fallback;
  }
};

export const loginWithGoogle = (next = "/genitori") => {
  if (IS_CF) {
    window.location.href = `${API}/auth/google/start?next=${encodeURIComponent(next)}`;
    return;
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + next;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const fetchBlob = async (path) => {
  const { data } = await http.get(path, { responseType: "blob" });
  return URL.createObjectURL(data);
};
